// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expense-form-container {
  min-height: calc(100vh - 118px);
  background: var(--grey-shade-three);
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
@media (max-width: 768px) {
  .expense-form-container {
    padding: 1rem;
  }
}
.expense-form-container .expense-form-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  z-index: 1001;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.expense-form-container .expense-form-close-button:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.expense-form-container .expense-form-close-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modal-expense-form-container {
  padding: 0rem !important;
  min-height: auto;
}

.uploaded-file {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.uploaded-file a {
  color: #0369a1;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  flex: 1 1;
}
.uploaded-file a:hover {
  text-decoration: underline;
}
.uploaded-file .cancel-upload-button {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.uploaded-file .cancel-upload-button:hover {
  background-color: #dc2626;
}
.uploaded-file .cancel-upload-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}

.expense-form-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  animation: expense-form-fade-in 0.3s ease-out;
  width: 70%;
}
@media (max-width: 768px) {
  .expense-form-card {
    padding: 1rem;
    width: 100%;
  }
}
.expense-form-card .expense-form-title {
  font-size: 1.3rem;
  font-weight: 500;
  color: #374151;
  text-align: center;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .expense-form-card .expense-form-title {
    font-size: 1.25rem;
  }
}
.expense-form-card .expense-form-divider {
  border: none;
  border-top: 1px solid #e5e7eb;
  margin: 1.5rem 0;
}
.expense-form-card .form-section {
  margin-bottom: 1.5rem;
}
.expense-form-card .form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}
.expense-form-card .form-section h3 {
  font-size: 1rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e5e7eb;
}
.expense-form-card .form-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}
.expense-form-card .form-row:last-child {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .expense-form-card .form-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.expense-form-card .expense-form-group,
.expense-form-card .form-group {
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
}
.expense-form-card .expense-form-group:last-child,
.expense-form-card .form-group:last-child {
  margin-bottom: 0;
}
.expense-form-card .expense-form-group .expense-form-label,
.expense-form-card .expense-form-group label,
.expense-form-card .form-group .expense-form-label,
.expense-form-card .form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.expense-form-card .expense-form-group .expense-form-label .expense-form-required,
.expense-form-card .expense-form-group label .expense-form-required,
.expense-form-card .form-group .expense-form-label .expense-form-required,
.expense-form-card .form-group label .expense-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.expense-form-card .expense-form-group .expense-form-form-textarea,
.expense-form-card .form-group .expense-form-form-textarea {
  height: 4rem;
  resize: vertical;
  line-height: 1.5;
}
.expense-form-card .expense-form-input-container {
  position: relative;
}
.expense-form-card .expense-form-input-container .expense-form-icon-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0 0.75rem;
  pointer-events: none;
  color: #6b7280;
  font-weight: 500;
}
.expense-form-card .expense-form-input-container .expense-form-icon-container span {
  font-size: 0.875rem;
}
.expense-form-card .expense-form-input,
.expense-form-card .expense-form-form-select,
.expense-form-card .expense-form-form-textarea,
.expense-form-card .custom-dropdown-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.expense-form-card .expense-form-input:focus,
.expense-form-card .expense-form-form-select:focus,
.expense-form-card .expense-form-form-textarea:focus,
.expense-form-card .custom-dropdown-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.expense-form-card .expense-form-input::placeholder,
.expense-form-card .expense-form-form-select::placeholder,
.expense-form-card .expense-form-form-textarea::placeholder,
.expense-form-card .custom-dropdown-input::placeholder {
  color: #9ca3af;
}
.expense-form-card .expense-form-input:disabled,
.expense-form-card .expense-form-form-select:disabled,
.expense-form-card .expense-form-form-textarea:disabled,
.expense-form-card .custom-dropdown-input:disabled {
  background-color: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
}
.expense-form-card .expense-form-form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5rem 1.5rem;
  padding-right: 2.5rem;
}
.expense-form-card .expense-form-input,
.expense-form-card .expense-form-form-select {
  padding-right: 2.5rem;
}
.expense-form-card .expense-form-flex-row {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .expense-form-card .expense-form-flex-row {
    flex-direction: column;
    gap: 0.5rem;
  }
}
.expense-form-card .expense-form-flex-row .expense-form-col-half {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  font-size: 0.875rem;
  color: #374151;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-label .expense-form-required {
  color: #ef4444;
  margin-left: 0.25rem;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input,
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-family: inherit;
  color: #374151;
  background: #ffffff;
  box-sizing: border-box;
  height: 2.5rem;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input:focus,
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input:hover:not(:focus),
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date:hover:not(:focus) {
  border-color: #9ca3af;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input::placeholder,
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date::placeholder {
  color: #9ca3af;
}
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input:disabled,
.expense-form-card .expense-form-flex-row .expense-form-col-half .expense-form-input-date:disabled {
  background-color: #f9fafb;
  color: #6b7280;
  cursor: not-allowed;
}
.expense-form-card .case-selector {
  position: relative;
}
.expense-form-card .case-selector .dropdown-content {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  z-index: 1000;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  margin-top: 0.25rem;
  overflow: hidden;
  animation: dropdown-fade-in 0.2s ease-out;
}
.expense-form-card .case-selector .dropdown-content .dropdown-tabs {
  display: flex;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
}
.expense-form-card .case-selector .dropdown-content .dropdown-tabs button {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 2px solid transparent;
}
.expense-form-card .case-selector .dropdown-content .dropdown-tabs button:hover {
  background: #f3f4f6;
  color: #374151;
}
.expense-form-card .case-selector .dropdown-content .dropdown-tabs button.active {
  background: #ffffff;
  color: #3b82f6;
  font-weight: 600;
  border-bottom-color: #3b82f6;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options {
  max-height: 250px;
  overflow-y: auto;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option {
  padding: 0.75rem 1rem;
  cursor: pointer;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.2s ease;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option:hover {
  background: #f9fafb;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option.selected {
  background: #eff6ff;
  color: #1e40af;
  border-left: 3px solid #3b82f6;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option.selected .case-parties {
  font-weight: 600;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-parties {
  font-weight: 500;
  color: #374151;
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  line-height: 1.4;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-ref {
  font-size: 0.75rem;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", Menlo, monospace;
  background: #f3f4f6;
  padding: 0.125rem 0.375rem;
  border-radius: 0.25rem;
  display: inline-block;
  margin-bottom: 0.25rem;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .dropdown-option .case-info .case-number {
  font-size: 0.75rem;
  color: #9ca3af;
}
.expense-form-card .case-selector .dropdown-content .dropdown-options .no-data {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.expense-form-card .case-selector .dropdown-content .loading-state,
.expense-form-card .case-selector .dropdown-content .no-results,
.expense-form-card .case-selector .dropdown-content .empty-state {
  padding: 2rem 1rem;
  text-align: center;
  color: #6b7280;
  font-style: italic;
  font-size: 0.875rem;
}
.expense-form-card .case-selector .dropdown-content .loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.expense-form-card .case-selector .dropdown-content .loading-state::before {
  content: "";
  width: 16px;
  height: 16px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
.expense-form-card .upload-document-group .upload-document-container {
  border: 2px dashed #e2e8f0;
  border-radius: 0.375rem;
  padding: 2rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafafa;
}
.expense-form-card .upload-document-group .upload-document-container:hover {
  border-color: #3a86ff;
  background-color: #f8fafc;
}
.expense-form-card .upload-document-group .upload-document-container:focus-within {
  border-color: #3a86ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.expense-form-card .upload-document-group .upload-document-container .upload-icon-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  color: #6b7280;
}
.expense-form-card .upload-document-group .upload-document-container .upload-icon-container span {
  font-size: 0.875rem;
  font-weight: 500;
}
.expense-form-card .upload-document-group .upload-progress {
  margin-top: 1rem;
  text-align: center;
}
.expense-form-card .upload-document-group .upload-progress .progress-bar {
  width: 100%;
  height: 8px;
  background-color: #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}
.expense-form-card .upload-document-group .upload-progress .progress-bar .progress {
  height: 100%;
  background-color: #3b82f6;
  border-radius: 4px;
  transition: width 0.3s ease;
}
.expense-form-card .upload-document-group .upload-progress span {
  font-size: 0.75rem;
  color: #6b7280;
  font-weight: 500;
}
.expense-form-card .upload-document-group .uploaded-file {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background-color: #f0f9ff;
  border: 1px solid #bae6fd;
  border-radius: 0.375rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.expense-form-card .upload-document-group .uploaded-file a {
  color: #0369a1;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.875rem;
  flex: 1 1;
}
.expense-form-card .upload-document-group .uploaded-file a:hover {
  text-decoration: underline;
}
.expense-form-card .upload-document-group .uploaded-file .cancel-upload-button {
  background-color: #ef4444;
  color: white;
  border: none;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.expense-form-card .upload-document-group .uploaded-file .cancel-upload-button:hover {
  background-color: #dc2626;
}
.expense-form-card .upload-document-group .uploaded-file .cancel-upload-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);
}
.expense-form-card .expense-form-button-container {
  display: flex;
  justify-content: end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
@media (max-width: 768px) {
  .expense-form-card .expense-form-button-container {
    flex-direction: column;
  }
}
.expense-form-card .expense-form-button-container .expense-form-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-weight: 500;
  font-size: 0.875rem;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .expense-form-card .expense-form-button-container .expense-form-btn {
    width: 100%;
  }
}
.expense-form-card .expense-form-button-container .expense-form-btn.expense-form-btn-save {
  background-color: var(--primary-color);
  color: white;
}
.expense-form-card .expense-form-button-container .expense-form-btn.expense-form-btn-save:hover {
  background-color: #005a9a;
}
.expense-form-card .expense-form-button-container .expense-form-btn.expense-form-btn-save:focus {
  outline: none;
}
.expense-form-card .expense-form-button-container .expense-form-btn.expense-form-btn-save:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
  cursor: not-allowed;
  opacity: 0.6;
}
.expense-form-card .expense-form-button-container .expense-form-btn-cancel {
  padding: 8px 16px;
  border: 1px solid #ddd;
  background: white;
  color: #666;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}
.expense-form-card .expense-form-button-container .expense-form-btn-cancel:hover {
  background-color: #f8f9fa;
}

.no-spinner::-webkit-outer-spin-button,
.no-spinner::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.modal-expense-form-card {
  border: none;
  width: 100% !important;
}
.modal-expense-form-card .modal-expense-form-title {
  font-size: 1.3rem !important;
}

.client-modal-header .close-cross {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  transition: all 0.2s ease;
}
.client-modal-header .close-cross:hover {
  color: #374151;
  background-color: #f3f4f6;
}
.client-modal-header .close-cross:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.exp-service-modal-body h3 {
  font-size: 1.2rem;
  font-weight: 500;
  color: #374151;
  margin: 0 0 1rem 0;
}
.exp-service-modal-body .new-service-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #d1d5db;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
  height: 2.5rem;
}
.exp-service-modal-body .new-service-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.exp-service-modal-body .new-service-input::placeholder {
  color: #9ca3af;
}
.exp-service-modal-body .submit-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.exp-service-modal-body .submit-btn:hover {
  background-color: #005a9a;
}
.exp-service-modal-body .submit-btn:disabled {
  background-color: #9ca3af;
  cursor: not-allowed;
}

@keyframes expense-form-fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes dropdown-fade-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {
  width: 6px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
}

.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

@media (max-width: 768px) {
  .expense-form-container .expense-form-card {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .expense-form-container {
    padding: 0.5rem;
  }
  .expense-form-container .expense-form-card {
    padding: 0.75rem;
  }
  .expense-form-container .expense-form-card .expense-form-title {
    font-size: 1.125rem;
  }
  .expense-form-container .expense-form-card .expense-form-group .expense-form-input,
  .expense-form-container .expense-form-card .expense-form-group .expense-form-form-select,
  .expense-form-container .expense-form-card .expense-form-group .expense-form-form-textarea,
  .expense-form-container .expense-form-card .expense-form-group .custom-dropdown-input,
  .expense-form-container .expense-form-card .form-group .expense-form-input,
  .expense-form-container .expense-form-card .form-group .expense-form-form-select,
  .expense-form-container .expense-form-card .form-group .expense-form-form-textarea,
  .expense-form-container .expense-form-card .form-group .custom-dropdown-input {
    padding: 0.375rem;
    font-size: 0.8125rem;
  }
  .expense-form-container .expense-form-card .expense-form-button-container .expense-form-btn {
    padding: 0.5rem 1rem;
    font-size: 0.8125rem;
  }
}
@media print {
  .expense-form-container {
    background: white;
    padding: 0;
  }
  .expense-form-container .expense-form-card {
    box-shadow: none;
    border: 1px solid #000;
  }
  .expense-form-container .expense-form-button-container,
  .expense-form-container .dropdown-content,
  .expense-form-container .expense-form-close-button {
    display: none;
  }
}
.expense-form-card input:focus-visible,
.expense-form-card select:focus-visible,
.expense-form-card textarea:focus-visible,
.expense-form-card button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* MODIFICATION: ADDED STYLES FOR THE NEW "ADD FIELD" MODAL */
.confirmation-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050; /* Higher z-index to appear above the main form modal */
  padding: 20px;
  box-sizing: border-box;
}

.confirmation-modal {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
  width: 700px;
  max-width: 95%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid #e5e7eb;
  position: relative;
  animation: expense-form-fade-in 0.2s ease-out;
}
.confirmation-modal.notinvoice {
  width: 420px;
  gap: 16px;
}
.confirmation-modal.notinvoice .branch-form-close-button {
  top: 12px;
  right: 12px;
}

.confirmation-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
}
.confirmation-actions.notinvoice {
  border-top: none;
  padding-top: 0;
}
.confirmation-actions .confirm-btn,
.confirmation-actions .cancel-btn {
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}
.confirmation-actions .confirm-btn:disabled,
.confirmation-actions .cancel-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.confirmation-actions .confirm-btn {
  background: var(--primary-color);
  color: white;
}
.confirmation-actions .confirm-btn:hover:not(:disabled) {
  filter: brightness(95%);
}
.confirmation-actions .confirm-btn:disabled {
  background-color: #d1d5db;
  color: #9ca3af;
}
.confirmation-actions .cancel-btn {
  background: #6b7280;
  color: white;
}
.confirmation-actions .cancel-btn:hover:not(:disabled) {
  background: #4b5563;
}

.add-new-field-modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.add-new-field-modal-content h3 {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  text-align: left;
  border-bottom: none;
  padding-bottom: 0;
}
.add-new-field-modal-content .add-new-field-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  box-sizing: border-box;
}
.add-new-field-modal-content .add-new-field-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/forms/ExpenseForm/ExpenseForm.scss"],"names":[],"mappings":"AAAA;EACE,+BAAA;EACA,mCAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EAVF;IAWI,aAAA;EAEF;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AACJ;AACI;EACE,yBAAA;EACA,cAAA;AACN;AAEI;EACE,aAAA;EACA,6CAAA;AAAN;;AAIA;EACE,wBAAA;EACA,gBAAA;AADF;;AAGA;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAAF;AAEE;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AAAJ;AAEI;EACE,0BAAA;AAAN;AAIE;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAFJ;AAII;EACE,yBAAA;AAFN;AAKI;EACE,aAAA;EACA,4CAAA;AAHN;;AASA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;EACA,6CAAA;EACA,UAAA;AANF;AAQE;EATF;IAUI,aAAA;IACA,WAAA;EALF;AACF;AAQE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;AANJ;AAQI;EAPF;IAQI,kBAAA;EALJ;AACF;AASE;EACE,YAAA;EACA,6BAAA;EACA,gBAAA;AAPJ;AAWE;EACE,qBAAA;AATJ;AAaI;EACE,mBAAA;EACA,gBAAA;EACA,iBAAA;AAXN;AAcI;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,gCAAA;AAZN;AAiBE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,gBAAA;AAfN;AAkBI;EATF;IAUI,sBAAA;IACA,WAAA;EAfJ;AACF;AAmBE;;EAEE,qBAAA;EACA,aAAA;EACA,sBAAA;AAjBJ;AAmBI;;EACE,gBAAA;AAhBN;AAmBI;;;;EAEE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAfN;AAiBM;;;;EACE,cAAA;EACA,oBAAA;AAZR;AAgBI;;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;AAbN;AAiBE;EACE,kBAAA;AAfJ;AAiBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;AAfN;AAiBM;EACE,mBAAA;AAfR;AAoBE;;;;EAIE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAlBJ;AAoBI;;;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAfN;AAsBI;;;;EACE,cAAA;AAjBN;AAoBI;;;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AAfN;AAmBE;EACE,gBAAA;EACA,yDAAA;EACA,wCAAA;EACA,4BAAA;EACA,8BAAA;EACA,qBAAA;AAjBJ;AAoBE;;EAEE,qBAAA;AAlBJ;AAsBE;EACE,aAAA;EACA,SAAA;EACA,qBAAA;AApBJ;AAsBI;EALF;IAMI,sBAAA;IACA,WAAA;EAnBJ;AACF;AAqBI;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AAnBN;AAqBM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AAnBR;AAqBQ;EACE,cAAA;EACA,oBAAA;AAnBV;AAuBM;;EAEE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AArBR;AAuBQ;;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AApBV;AAuBQ;;EACE,qBAAA;AApBV;AAuBQ;;EACE,cAAA;AApBV;AAuBQ;;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;AApBV;AA2BE;EACE,kBAAA;AAzBJ;AA4BI;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,qFAAA;EAEA,mBAAA;EACA,gBAAA;EACA,yCAAA;AA3BN;AA6BM;EACE,aAAA;EACA,mBAAA;EACA,gCAAA;AA3BR;AA6BQ;EACE,SAAA;EACA,qBAAA;EACA,YAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AA3BV;AA6BU;EACE,mBAAA;EACA,cAAA;AA3BZ;AA8BU;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,4BAAA;AA5BZ;AA8FM;EACE,iBAAA;EACA,gBAAA;AA5FR;AA8FQ;EACE,qBAAA;EACA,eAAA;EACA,gCAAA;EACA,yBAAA;AA5FV;AA8FU;EACE,mBAAA;AA5FZ;AA+FU;EACE,mBAAA;EACA,cAAA;EACA,8BAAA;AA7FZ;AA+FY;EACE,gBAAA;AA7Fd;AAkGY;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;AAhGd;AAmGY;EACE,kBAAA;EACA,cAAA;EACA,mGAAA;EAEA,mBAAA;EACA,0BAAA;EACA,sBAAA;EACA,qBAAA;EACA,sBAAA;AAlGd;AAqGY;EACE,kBAAA;EACA,cAAA;AAnGd;AAwGQ;EACE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAtGV;AA0GM;;;EAGE,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAxGR;AA2GM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAzGR;AA2GQ;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AAzGV;AAiHI;EACE,0BAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;AA/GN;AAiHM;EACE,qBAAA;EACA,yBAAA;AA/GR;AAkHM;EACE,qBAAA;EACA,6CAAA;AAhHR;AAmHM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;AAjHR;AAmHQ;EACE,mBAAA;EACA,gBAAA;AAjHV;AAsHI;EACE,gBAAA;EACA,kBAAA;AApHN;AAsHM;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AApHR;AAsHQ;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,2BAAA;AApHV;AAwHM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;AAtHR;AA0HI;EACE,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAxHN;AA0HM;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,SAAA;AAxHR;AA0HQ;EACE,0BAAA;AAxHV;AA4HM;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA1HR;AA4HQ;EACE,yBAAA;AA1HV;AA6HQ;EACE,aAAA;EACA,4CAAA;AA3HV;AAkIE;EACE,aAAA;EACA,oBAAA;EACA,SAAA;EAEA,iBAAA;EACA,6BAAA;AAjIJ;AAmII;EARF;IASI,sBAAA;EAhIJ;AACF;AAkII;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAhIN;AAkIM;EAVF;IAWI,WAAA;EA/HN;AACF;AAiIM;EACE,sCAAA;EACA,YAAA;AA/HR;AAiIQ;EACE,yBAAA;AA/HV;AAkIQ;EACE,aAAA;AAhIV;AAmIQ;EACE,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,YAAA;AAjIV;AAqII;EAmBE,iBAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AArJN;AAuJM;EACE,yBAAA;AArJR;;AA0JA;;EAEE,wBAAA;EACA,SAAA;AAvJF;;AA0JA;EACE,YAAA;EACA,sBAAA;AAvJF;AAyJE;EACE,4BAAA;AAvJJ;;AAmKE;EACE,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;AAhKJ;AAkKI;EACE,cAAA;EACA,yBAAA;AAhKN;AAmKI;EACE,aAAA;EACA,6CAAA;AAjKN;;AAyKE;EAKE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AA1KJ;AA6KE;EACE,WAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AA3KJ;AA6KI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA3KN;AA8KI;EACE,cAAA;AA5KN;AAgLE;EA2BE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAxMJ;AA0MI;EACE,yBAAA;AAxMN;AA2MI;EACE,yBAAA;EACA,mBAAA;AAzMN;;AA+MA;EACE;IACE,UAAA;IACA,2BAAA;EA5MF;EA+MA;IACE,UAAA;IACA,wBAAA;EA7MF;AACF;AAgNA;EACE;IACE,UAAA;IACA,2BAAA;EA9MF;EAiNA;IACE,UAAA;IACA,wBAAA;EA/MF;AACF;AAmNA;EACE,UAAA;AAjNF;;AAoNA;EACE,mBAAA;EACA,kBAAA;AAjNF;;AAoNA;EACE,mBAAA;EACA,kBAAA;EACA,8CAAA;EAAA,sCAAA;AAjNF;;AAoNA;EAGE,mBAAA;AAnNF;;AAuNA;EAEI;IACE,WAAA;EArNJ;AACF;AAyNA;EACE;IACE,eAAA;EAvNF;EAyNE;IACE,gBAAA;EAvNJ;EAyNI;IACE,mBAAA;EAvNN;EA4NM;;;;;;;;IAIE,iBAAA;IACA,oBAAA;EAtNR;EA2NM;IACE,oBAAA;IACA,oBAAA;EAzNR;AACF;AAgOA;EACE;IACE,iBAAA;IACA,UAAA;EA9NF;EAgOE;IACE,gBAAA;IACA,sBAAA;EA9NJ;EAiOE;;;IAGE,aAAA;EA/NJ;AACF;AAqOE;;;;EAIE,0BAAA;EACA,mBAAA;AAnOJ;;AAuOA,6DAAA;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA,EAAA,uDAAA;EACA,aAAA;EACA,sBAAA;AArOF;;AAwOA;EACE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,6CAAA;AArOF;AAuOE;EACE,YAAA;EACA,SAAA;AArOJ;AAuOI;EACE,SAAA;EACA,WAAA;AArON;;AA0OA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,iBAAA;EACA,6BAAA;AAvOF;AAyOE;EACE,gBAAA;EACA,cAAA;AAvOJ;AA0OE;;EAEE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAxOJ;AA0OI;;EACE,mBAAA;EACA,YAAA;AAvON;AA2OE;EACE,gCAAA;EACA,YAAA;AAzOJ;AA2OI;EACE,uBAAA;AAzON;AA4OI;EACE,yBAAA;EACA,cAAA;AA1ON;AA8OE;EACE,mBAAA;EACA,YAAA;AA5OJ;AA8OI;EACE,mBAAA;AA5ON;;AAkPA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA/OF;AAiPE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AA/OJ;AAkPE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;AAhPJ;AAkPI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAhPN","sourcesContent":[".expense-form-container {\n  min-height: calc(100vh - 118px);\n  background: var(--grey-shade-three);\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n  }\n\n  // Close button for modal\n  .expense-form-close-button {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    z-index: 1001;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: #f3f4f6;\n      color: #374151;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}\n.modal-expense-form-container {\n  padding: 0rem !important;\n  min-height: auto;\n}\n.uploaded-file {\n  margin-top: 1rem;\n  padding: 0.75rem 1rem;\n  background-color: #f0f9ff;\n  border: 1px solid #bae6fd;\n  border-radius: 0.375rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n\n  a {\n    color: #0369a1;\n    text-decoration: none;\n    font-weight: 500;\n    font-size: 0.875rem;\n    flex: 1;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  .cancel-upload-button {\n    background-color: #ef4444;\n    color: white;\n    border: none;\n    padding: 0.375rem 0.75rem;\n    border-radius: 0.25rem;\n    font-size: 0.75rem;\n    font-weight: 500;\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &:hover {\n      background-color: #dc2626;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);\n    }\n  }\n}\n\n// Form Wrapper - Match LabelForm wrapper structure\n.expense-form-card {\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  animation: expense-form-fade-in 0.3s ease-out;\n  width: 70%;\n\n  @media (max-width: 768px) {\n    padding: 1rem;\n    width: 100%;\n  }\n\n  // Title styling\n  .expense-form-title {\n    font-size: 1.3rem;\n    font-weight: 500;\n    color: #374151;\n    text-align: center;\n    margin-bottom: 0.5rem;\n\n    @media (max-width: 768px) {\n      font-size: 1.25rem;\n    }\n  }\n\n  // Divider styling\n  .expense-form-divider {\n    border: none;\n    border-top: 1px solid #e5e7eb;\n    margin: 1.5rem 0;\n  }\n\n  // Form sections\n  .form-section {\n    margin-bottom: 1.5rem;\n    // padding-bottom: 1.5rem;\n    // border-bottom: 1px solid #f3f4f6;\n\n    &:last-of-type {\n      border-bottom: none;\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n\n    h3 {\n      font-size: 1rem;\n      font-weight: 500;\n      color: #374151;\n      margin: 0 0 1rem 0;\n      padding-bottom: 0.5rem;\n      border-bottom: 1px solid #e5e7eb;\n    }\n  }\n\n  // Form rows and groups\n  .form-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 1rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n  }\n\n  // Form groups\n  .expense-form-group,\n  .form-group {\n    margin-bottom: 0.5rem;\n    display: flex;\n    flex-direction: column;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    .expense-form-label,\n    label {\n      display: block;\n      margin-bottom: 0.5rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      color: #374151;\n\n      .expense-form-required {\n        color: #ef4444;\n        margin-left: 0.25rem;\n      }\n    }\n\n    .expense-form-form-textarea {\n      height: 4rem;\n      resize: vertical;\n      line-height: 1.5;\n    }\n  }\n\n  .expense-form-input-container {\n    position: relative;\n\n    .expense-form-icon-container {\n      position: absolute;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      display: flex;\n      align-items: center;\n      padding: 0 0.75rem;\n      pointer-events: none;\n      color: #6b7280;\n      font-weight: 500;\n\n      span {\n        font-size: 0.875rem;\n      }\n    }\n  }\n\n  .expense-form-input,\n  .expense-form-form-select,\n  .expense-form-form-textarea,\n  .custom-dropdown-input {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-family: inherit;\n    color: #374151;\n    background: #ffffff;\n    box-sizing: border-box;\n    height: 2.5rem;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n\n    &:hover:not(:focus) {\n      //border-color: #9ca3af;\n    }\n\n    &::placeholder {\n      color: #9ca3af;\n    }\n\n    &:disabled {\n      background-color: #e9ecef;\n      color: #6c757d;\n      cursor: not-allowed;\n    }\n  }\n\n  .expense-form-form-select {\n    appearance: none;\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n    background-position: right 0.5rem center;\n    background-repeat: no-repeat;\n    background-size: 1.5rem 1.5rem;\n    padding-right: 2.5rem;\n  }\n\n  .expense-form-input,\n  .expense-form-form-select {\n    padding-right: 2.5rem;\n  }\n\n  // Two column layout for expense form\n  .expense-form-flex-row {\n    display: flex;\n    gap: 1rem;\n    margin-bottom: 0.5rem;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n      gap: 0.5rem;\n    }\n\n    .expense-form-col-half {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n\n      .expense-form-label {\n        display: block;\n        margin-bottom: 0.5rem;\n        font-weight: 500;\n        font-size: 0.875rem;\n        color: #374151;\n\n        .expense-form-required {\n          color: #ef4444;\n          margin-left: 0.25rem;\n        }\n      }\n\n      .expense-form-input,\n      .expense-form-input-date {\n        width: 100%;\n        padding: 0.5rem;\n        border: 1px solid #d1d5db;\n        border-radius: 0.25rem;\n        font-size: 0.875rem;\n        font-family: inherit;\n        color: #374151;\n        background: #ffffff;\n        box-sizing: border-box;\n        height: 2.5rem;\n\n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n\n        &:hover:not(:focus) {\n          border-color: #9ca3af;\n        }\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n\n        &:disabled {\n          background-color: #f9fafb;\n          color: #6b7280;\n          cursor: not-allowed;\n        }\n      }\n    }\n  }\n\n  // Case Selector - Match LabelForm exactly\n  .case-selector {\n    position: relative;\n\n    // Dropdown content\n    .dropdown-content {\n      position: absolute;\n      top: 100%;\n      left: 0;\n      width: 100%;\n      background: #ffffff;\n      border: 1px solid #d1d5db;\n      border-radius: 0.375rem;\n      z-index: 1000;\n      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\n        0 10px 10px -5px rgba(0, 0, 0, 0.04);\n      margin-top: 0.25rem;\n      overflow: hidden;\n      animation: dropdown-fade-in 0.2s ease-out;\n\n      .dropdown-tabs {\n        display: flex;\n        background: #f9fafb;\n        border-bottom: 1px solid #e5e7eb;\n\n        button {\n          flex: 1;\n          padding: 0.75rem 1rem;\n          border: none;\n          background: transparent;\n          color: #6b7280;\n          font-weight: 500;\n          font-size: 0.875rem;\n          cursor: pointer;\n          transition: all 0.2s ease;\n          border-bottom: 2px solid transparent;\n\n          &:hover {\n            background: #f3f4f6;\n            color: #374151;\n          }\n\n          &.active {\n            background: #ffffff;\n            color: #3b82f6;\n            font-weight: 600;\n            border-bottom-color: #3b82f6;\n          }\n        }\n      }\n\n      //   .dropdown-options {\n      //     max-height: 250px;\n      //     overflow-y: auto;\n\n      //     .dropdown-option {\n      //       padding: 0.75rem 1rem;\n      //       cursor: pointer;\n      //       border-bottom: 1px solid #f3f4f6;\n      //       transition: all 0.2s ease;\n\n      //       &:hover {\n      //         background: #f9fafb;\n      //       }\n\n      //       &.selected {\n      //         background: #eff6ff;\n      //         //color: #1e40af;\n      //         border-left: 3px solid #3b82f6;\n\n      //         .case-parties {\n      //           font-weight: 600;\n      //         }\n      //       }\n\n      //       .case-info {\n      //         .case-parties {\n      //           font-weight: 500;\n      //           color: #374151;\n      //           font-size: 0.875rem;\n      //           margin-bottom: 0.25rem;\n      //           line-height: 1.4;\n\n      //         }\n\n      //         .case-ref {\n      //           font-size: 0.75rem;\n      //           color: #6b7280;\n      //           font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas, \"Liberation Mono\", Menlo, monospace;\n      //           background: #f3f4f6;\n      //           padding: 0.125rem 0.375rem;\n      //           border-radius: 0.25rem;\n      //           display: inline-block;\n      //           margin-bottom: 0.25rem;\n      //         }\n\n      //         .case-number {\n      //           font-size: 0.75rem;\n      //           color: #9ca3af;\n      //         }\n      //       }\n      //     }\n\n      //     .no-data {\n      //       padding: 2rem 1rem;\n      //       text-align: center;\n      //       color: #6b7280;\n      //       font-style: italic;\n      //       font-size: 0.875rem;\n      //     }\n      //   }\n      // }\n      .dropdown-options {\n        max-height: 250px;\n        overflow-y: auto;\n\n        .dropdown-option {\n          padding: 0.75rem 1rem;\n          cursor: pointer;\n          border-bottom: 1px solid #f3f4f6;\n          transition: all 0.2s ease;\n\n          &:hover {\n            background: #f9fafb;\n          }\n\n          &.selected {\n            background: #eff6ff;\n            color: #1e40af;\n            border-left: 3px solid #3b82f6;\n\n            .case-parties {\n              font-weight: 600;\n            }\n          }\n\n          .case-info {\n            .case-parties {\n              font-weight: 500;\n              color: #374151;\n              font-size: 0.875rem;\n              margin-bottom: 0.25rem;\n              line-height: 1.4;\n            }\n\n            .case-ref {\n              font-size: 0.75rem;\n              color: #6b7280;\n              font-family: ui-monospace, SFMono-Regular, \"SF Mono\", Consolas,\n                \"Liberation Mono\", Menlo, monospace;\n              background: #f3f4f6;\n              padding: 0.125rem 0.375rem;\n              border-radius: 0.25rem;\n              display: inline-block;\n              margin-bottom: 0.25rem;\n            }\n\n            .case-number {\n              font-size: 0.75rem;\n              color: #9ca3af;\n            }\n          }\n        }\n\n        .no-data {\n          padding: 2rem 1rem;\n          text-align: center;\n          color: #6b7280;\n          font-style: italic;\n          font-size: 0.875rem;\n        }\n      }\n\n      .loading-state,\n      .no-results,\n      .empty-state {\n        padding: 2rem 1rem;\n        text-align: center;\n        color: #6b7280;\n        font-style: italic;\n        font-size: 0.875rem;\n      }\n\n      .loading-state {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 0.5rem;\n\n        &::before {\n          content: \"\";\n          width: 16px;\n          height: 16px;\n          border: 2px solid #e5e7eb;\n          border-top: 2px solid #3b82f6;\n          border-radius: 50%;\n          animation: spin 1s linear infinite;\n        }\n      }\n    }\n  }\n\n  // Upload document styles\n  .upload-document-group {\n    .upload-document-container {\n      border: 2px dashed #e2e8f0;\n      border-radius: 0.375rem;\n      padding: 2rem;\n      text-align: center;\n      cursor: pointer;\n      transition: all 0.2s ease;\n      background: #fafafa;\n\n      &:hover {\n        border-color: #3a86ff;\n        background-color: #f8fafc;\n      }\n\n      &:focus-within {\n        border-color: #3a86ff;\n        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n      }\n\n      .upload-icon-container {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 0.75rem;\n        color: #6b7280;\n\n        span {\n          font-size: 0.875rem;\n          font-weight: 500;\n        }\n      }\n    }\n\n    .upload-progress {\n      margin-top: 1rem;\n      text-align: center;\n\n      .progress-bar {\n        width: 100%;\n        height: 8px;\n        background-color: #e5e7eb;\n        border-radius: 4px;\n        overflow: hidden;\n        margin-bottom: 0.5rem;\n\n        .progress {\n          height: 100%;\n          background-color: #3b82f6;\n          border-radius: 4px;\n          transition: width 0.3s ease;\n        }\n      }\n\n      span {\n        font-size: 0.75rem;\n        color: #6b7280;\n        font-weight: 500;\n      }\n    }\n\n    .uploaded-file {\n      margin-top: 1rem;\n      padding: 0.75rem 1rem;\n      background-color: #f0f9ff;\n      border: 1px solid #bae6fd;\n      border-radius: 0.375rem;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      gap: 1rem;\n\n      a {\n        color: #0369a1;\n        text-decoration: none;\n        font-weight: 500;\n        font-size: 0.875rem;\n        flex: 1;\n\n        &:hover {\n          text-decoration: underline;\n        }\n      }\n\n      .cancel-upload-button {\n        background-color: #ef4444;\n        color: white;\n        border: none;\n        padding: 0.375rem 0.75rem;\n        border-radius: 0.25rem;\n        font-size: 0.75rem;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s ease;\n\n        &:hover {\n          background-color: #dc2626;\n        }\n\n        &:focus {\n          outline: none;\n          box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.3);\n        }\n      }\n    }\n  }\n\n  // Form actions to match LabelForm\n  .expense-form-button-container {\n    display: flex;\n    justify-content: end;\n    gap: 1rem;\n    //margin-top: 1rem;\n    padding-top: 1rem;\n    border-top: 1px solid #e5e7eb;\n\n    @media (max-width: 768px) {\n      flex-direction: column;\n    }\n\n    .expense-form-btn {\n      padding: 0.75rem 1.5rem;\n      border: none;\n      border-radius: 0.375rem;\n      font-weight: 500;\n      font-size: 0.875rem;\n      cursor: pointer;\n      min-width: 120px;\n      transition: all 0.2s ease;\n\n      @media (max-width: 768px) {\n        width: 100%;\n      }\n\n      &.expense-form-btn-save {\n        background-color: var(--primary-color);\n        color: white;\n\n        &:hover {\n          background-color: #005a9a;\n        }\n\n        &:focus {\n          outline: none;\n        }\n\n        &:disabled {\n          background-color: #d1d5db;\n          color: #9ca3af;\n          cursor: not-allowed;\n          opacity: 0.6;\n        }\n      }\n    }\n    .expense-form-btn-cancel {\n      // background-color: #dc2626;\n      // color: white;\n\n      // &:hover:not(:disabled) {\n      //   background-color: #b91c1c;\n      // }\n\n      // &:focus {\n      //   outline: none;\n      //   box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.3);\n      // }\n\n      // &:disabled {\n      //   background-color: #d1d5db;\n      //   color: #9ca3af;\n      //   cursor: not-allowed;\n      //   opacity: 0.6;\n      // }\n      padding: 8px 16px;\n      border: 1px solid #ddd;\n      background: white;\n      color: #666;\n      border-radius: 4px;\n      cursor: pointer;\n      font-size: 14px;\n\n      &:hover {\n        background-color: #f8f9fa;\n      }\n    }\n  }\n}\n.no-spinner::-webkit-outer-spin-button,\n.no-spinner::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.modal-expense-form-card {\n  border: none;\n  width: 100% !important;\n\n  .modal-expense-form-title {\n    font-size: 1.3rem !important;\n  }\n}\n\n// Modal styles\n.client-modal-header {\n  // display: flex;\n  // justify-content: flex-end;\n  // padding: 1rem;\n  // background-color: #f9fafb;\n  // border-bottom: 1px solid #e5e7eb;\n\n  .close-cross {\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    color: #6b7280;\n    cursor: pointer;\n    padding: 0;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 0.25rem;\n    transition: all 0.2s ease;\n\n    &:hover {\n      color: #374151;\n      background-color: #f3f4f6;\n    }\n\n    &:focus {\n      outline: none;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}\n\n.exp-service-modal-body {\n  //padding: 1.5rem;\n\n  h3 {\n    // font-size: 1.25rem;\n    // font-weight: 500;\n    // color: #374151;\n    // margin: 0 0 1rem 0;\n    font-size: 1.2rem;\n    font-weight: 500;\n    color: #374151;\n    margin: 0 0 1rem 0;\n  }\n\n  .new-service-input {\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #d1d5db;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    margin-bottom: 1rem;\n    box-sizing: border-box;\n    height: 2.5rem;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n\n    &::placeholder {\n      color: #9ca3af;\n    }\n  }\n\n  .submit-btn {\n    // background-color: #16a34a;\n    // color: white;\n    // border: none;\n    // padding: 0.75rem 1.5rem;\n    // border-radius: 0.375rem;\n    // font-size: 0.875rem;\n    // font-weight: 500;\n    // cursor: pointer;\n    // min-width: 120px;\n    // transition: all 0.2s ease;\n\n    // &:hover:not(:disabled) {\n    //   background-color: #15803d;\n    // }\n\n    // &:focus {\n    //   outline: none;\n    //   box-shadow: 0 0 0 3px rgba(34, 197, 94, 0.3);\n    // }\n\n    // &:disabled {\n    //   background-color: #d1d5db;\n    //   color: #9ca3af;\n    //   cursor: not-allowed;\n    //   opacity: 0.6;\n    // }\n    background-color: var(--primary-color);\n    color: white;\n    border: none;\n    padding: 0.5rem 1rem;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    cursor: pointer;\n\n    &:hover {\n      background-color: #005a9a;\n    }\n\n    &:disabled {\n      background-color: #9ca3af;\n      cursor: not-allowed;\n    }\n  }\n}\n\n// Animations\n@keyframes expense-form-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes dropdown-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// Scrollbar styling for dropdown\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar {\n  width: 6px;\n}\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.case-selector .dropdown-content .dropdown-options::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n  transition: background-color 0.2s ease;\n}\n\n.case-selector\n  .dropdown-content\n  .dropdown-options::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n// Responsive design improvements\n@media (max-width: 768px) {\n  .expense-form-container {\n    .expense-form-card {\n      width: 100%;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .expense-form-container {\n    padding: 0.5rem;\n\n    .expense-form-card {\n      padding: 0.75rem;\n\n      .expense-form-title {\n        font-size: 1.125rem;\n      }\n\n      .expense-form-group,\n      .form-group {\n        .expense-form-input,\n        .expense-form-form-select,\n        .expense-form-form-textarea,\n        .custom-dropdown-input {\n          padding: 0.375rem;\n          font-size: 0.8125rem;\n        }\n      }\n\n      .expense-form-button-container {\n        .expense-form-btn {\n          padding: 0.5rem 1rem;\n          font-size: 0.8125rem;\n        }\n      }\n    }\n  }\n}\n\n// Print styles\n@media print {\n  .expense-form-container {\n    background: white;\n    padding: 0;\n\n    .expense-form-card {\n      box-shadow: none;\n      border: 1px solid #000;\n    }\n\n    .expense-form-button-container,\n    .dropdown-content,\n    .expense-form-close-button {\n      display: none;\n    }\n  }\n}\n\n// Focus visible improvements for accessibility\n.expense-form-card {\n  input:focus-visible,\n  select:focus-visible,\n  textarea:focus-visible,\n  button:focus-visible {\n    outline: 2px solid #3b82f6;\n    outline-offset: 2px;\n  }\n}\n\n/* MODIFICATION: ADDED STYLES FOR THE NEW \"ADD FIELD\" MODAL */\n\n.confirmation-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050; /* Higher z-index to appear above the main form modal */\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.confirmation-modal {\n  background: #ffffff;\n  padding: 24px;\n  border-radius: 8px;\n  width: 700px;\n  max-width: 95%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  border: 1px solid #e5e7eb;\n  position: relative;\n  animation: expense-form-fade-in 0.2s ease-out;\n\n  &.notinvoice {\n    width: 420px;\n    gap: 16px;\n\n    .branch-form-close-button {\n      top: 12px;\n      right: 12px;\n    }\n  }\n}\n\n.confirmation-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 1rem;\n  border-top: 1px solid #e5e7eb;\n\n  &.notinvoice {\n    border-top: none;\n    padding-top: 0;\n  }\n\n  .confirm-btn,\n  .cancel-btn {\n    padding: 8px 18px;\n    font-size: 14px;\n    font-weight: 500;\n    border-radius: 6px;\n    border: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    min-width: 80px;\n\n    &:disabled {\n      cursor: not-allowed;\n      opacity: 0.6;\n    }\n  }\n\n  .confirm-btn {\n    background: var(--primary-color);\n    color: white;\n\n    &:hover:not(:disabled) {\n      filter: brightness(95%);\n    }\n\n    &:disabled {\n      background-color: #d1d5db;\n      color: #9ca3af;\n    }\n  }\n\n  .cancel-btn {\n    background: #6b7280;\n    color: white;\n\n    &:hover:not(:disabled) {\n      background: #4b5563;\n    }\n  }\n}\n\n// Styles for the content within the new modal\n.add-new-field-modal-content {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n\n  h3 {\n    font-size: 18px;\n    font-weight: 600;\n    color: #1f2937;\n    margin: 0;\n    text-align: left;\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n\n  .add-new-field-input {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 6px;\n    font-size: 14px;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      border-color: #3b82f6;\n      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
